"use strict";
/**
 * This file was auto-generated by Fern from our API Definition.
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.AgentPlatformSettingsResponseModel = void 0;
const core = __importStar(require("../../core"));
const AuthSettings_1 = require("./AuthSettings");
const EvaluationSettings_1 = require("./EvaluationSettings");
const WidgetConfig_1 = require("./WidgetConfig");
const LiteralJsonSchemaProperty_1 = require("./LiteralJsonSchemaProperty");
const ConversationInitiationClientDataConfigOutput_1 = require("./ConversationInitiationClientDataConfigOutput");
const AgentCallLimits_1 = require("./AgentCallLimits");
const PrivacyConfig_1 = require("./PrivacyConfig");
const AgentWorkspaceOverridesOutput_1 = require("./AgentWorkspaceOverridesOutput");
const AgentTestingSettings_1 = require("./AgentTestingSettings");
const SafetyResponseModel_1 = require("./SafetyResponseModel");
exports.AgentPlatformSettingsResponseModel = core.serialization.object({
    auth: AuthSettings_1.AuthSettings.optional(),
    evaluation: EvaluationSettings_1.EvaluationSettings.optional(),
    widget: WidgetConfig_1.WidgetConfig.optional(),
    dataCollection: core.serialization.property("data_collection", core.serialization.record(core.serialization.string(), LiteralJsonSchemaProperty_1.LiteralJsonSchemaProperty).optional()),
    overrides: ConversationInitiationClientDataConfigOutput_1.ConversationInitiationClientDataConfigOutput.optional(),
    callLimits: core.serialization.property("call_limits", AgentCallLimits_1.AgentCallLimits.optional()),
    privacy: PrivacyConfig_1.PrivacyConfig.optional(),
    workspaceOverrides: core.serialization.property("workspace_overrides", AgentWorkspaceOverridesOutput_1.AgentWorkspaceOverridesOutput.optional()),
    testing: AgentTestingSettings_1.AgentTestingSettings.optional(),
    safety: SafetyResponseModel_1.SafetyResponseModel.optional(),
});
